
const digest = '66681c94515da816d14966c221e037d0254e36ddba5ba7650bf34050e982af58';
const classes = {"wrapper":"_wrapper_xa4i2_1","content":"_content_xa4i2_13","title":"_title_xa4i2_18"};
const css = `._wrapper_xa4i2_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
}
._wrapper_xa4i2_1 img {
  height: 100px;
  width: 100px;
  border-radius: 100%;
}
._wrapper_xa4i2_1 ._content_xa4i2_13 {
  display: flex;
  flex-direction: column;
  color: #000000;
}
._wrapper_xa4i2_1 ._content_xa4i2_13 ._title_xa4i2_18 {
  color: #1d65d8;
  font-size: 16px;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  